var _title, _path;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgRhodeIsland = function SvgRhodeIsland(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192.63,
    height: 230,
    viewBox: "0 0 192.63 230",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "rhode-island")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61,174.66l-11.5-63.25-23-86.25L108.48,3.6,130,22.29,178.92,84.1l40.25,63.25-40.25,20.12-18.69-2.87-15.81,25.87-34.5,27.32L69.67,233.6Z",
    transform: "translate(-26.54 -3.6)"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRhodeIsland, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rhode-island.b1f3626f.svg";
export { ForwardRef as ReactComponent };